export const FEEDBACK_MAX_LENGTH = 3000;
